import * as React from 'react';
import * as styles from './banner.css';

import { bannerCard, trackShowStalkerBanner } from '../../utils/tracking';
import { SignInButtonContainer } from '../SignInButton';
import { CloseIconContainer } from '../CloseIcon';
import { Flex } from '../Flex';
import { Text } from '../Text';
import { ManRoundIcon } from '../ManRoundIcon';

export interface IBannerDispatchProps {
  closeBanner(): void;
}

const TIME_TO_HIDE_BANNER = 6000;

export class Banner extends React.Component<IBannerDispatchProps, {}> {
  private timerToHide: number;

  public componentDidMount() {
    trackShowStalkerBanner(bannerCard);

    this.timerToHide = window.setTimeout(() => this.props.closeBanner(), TIME_TO_HIDE_BANNER);
  }

  public componentWillUnmount() {
    clearTimeout(this.timerToHide);
  }

  public render() {
    return (
      <div className={styles['banner-content']}>
        <Flex direction="row" wrap="no-wrap" alignItems="center">
          <ManRoundIcon />
          <Flex flexBasis={16} />

          <div className={styles['text-box']}>
            <Text bold color="black" textSize="base">
              Войдите, чтобы добавлять в Избранное, сохранять поиск и писать сообщения
            </Text>
          </div>

          <Flex flexBasis={24} />
          <SignInButtonContainer />
          <Flex flexBasis={24} />
          <CloseIconContainer />
        </Flex>
      </div>
    );
  }
}
